module.exports = __webpack_public_path__ + "c6f4bcd2d96e0fcdda6ebb97d4e564c3.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/recorder.png
 ** module id = 1575
 ** module chunks = 0
 **/